var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"game-hud"}},[(_vm.component)?_c(_vm.component,{ref:"component",tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }